module.exports = __webpack_public_path__ + "static/media/IC.04f16e73.svg";